import Vue from "vue";
export default Vue.extend({
    props: {
        // Where your app should return users after callback finishes
        // (you can keep your old default)
        redirect: {
            type: String,
            default: "/account",
        },
        showHeader: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            isRedirecting: false,
            error: "",
            _timer: null,
        };
    },
    computed: {
        /**
         * Build your CIAM authorization URL.
         * Replace the placeholders with your real values.
         *
         * Recommended: keep these in env/config (still can be in your single .env).
         */
        loginUrl() {
            try {
                const authorizeEndpoint = process.env.VUE_APP_CIAM_AUTHORIZE_URL || "";
                const clientId = process.env.VUE_APP_CIAM_CLIENT_ID || "";
                const scope = "openid+profile+email+phone+UID";
                const responseType = "code";
                const callbackUrl = process.env.VUE_APP_CIAM_CALLBACK_URL || "";
                if (!authorizeEndpoint || !clientId || !callbackUrl)
                    return "#";
                const sep = authorizeEndpoint.includes("?")
                    ? (authorizeEndpoint.endsWith("?") || authorizeEndpoint.endsWith("&") ? "" : "&")
                    : "?";
                const query = [
                    `client_id=${clientId}`,
                    `scope=${scope}`,
                    `response_type=${responseType}`,
                    `redirect_uri=${callbackUrl}`,
                ].join("&");
                console.log(`${authorizeEndpoint}${sep}${query}`);
                return `${authorizeEndpoint}${sep}${query}`;
            }
            catch {
                return "#";
            }
        },
    },
    mounted() {
        // If config is missing, don't auto-redirect
        if (this.loginUrl === "#") {
            this.error =
                "Login is not configured. Please check CIAM settings (authorize URL / client ID).";
            return;
        }
        // Short delay so user sees the message
        this._timer = window.setTimeout(() => {
            this.startRedirect();
        }, 800);
    },
    beforeDestroy() {
        if (this._timer)
            window.clearTimeout(this._timer);
    },
    methods: {
        startRedirect() {
            this.isRedirecting = true;
            // Use assign() so back button returns to this page (use replace() if you prefer no back)
            window.location.assign(this.loginUrl);
        },
        onManualRedirect() {
            // user clicked the link
            this.startRedirect();
        },
    },
});
